<div class="pt-3 pl-md-4" *ngIf="membershipNotFound">
  <h2>Membership not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingExistingMembership">
  <h2>Loading Membership...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to
    {{ isNewMembership ? 'create' : 'edit' }}
    memberships.
  </h2>
</div>

<div *ngIf="(serverError === null) && !membershipNotFound && !loadingExistingMembership && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/memberships-and-passes" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('setup');$event.preventDefault();"
           [class.active]="currentSectionId === 'setup'">
          Setup
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('benefits');$event.preventDefault();"
           [class.active]="currentSectionId === 'benefits'">
          Benefits
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('pricing');$event.preventDefault();"
           [class.active]="currentSectionId === 'pricing'">
          Pricing
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('policies');$event.preventDefault();"
           [class.active]="currentSectionId === 'policies'">
          Policies
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#"
           (click)="scrollToElement('climber-app-text');$event.preventDefault();"
           [class.active]="currentSectionId === 'climber-app-text'">
          Climber App Text
        </a>
      </li>
      <li class="nav-item"
          *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().has_mailchimp_integration">
        <a class="nav-link" href="#"
           (click)="scrollToElement('mailchimp');$event.preventDefault();"
           [class.active]="currentSectionId === 'mailchimp'">
          Mailchimp
        </a>
      </li>
      <li class="nav-item"
          *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().pos_software === OrgPOSSoftware.square">
        <a class="nav-link" href="#"
           (click)="scrollToElement('square');$event.preventDefault();"
           [class.active]="currentSectionId === 'square'">
          Square
        </a>
      </li>
      <li class="nav-item"
          *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().pos_software === OrgPOSSoftware.lightspeed">
        <a class="nav-link" href="#"
           (click)="scrollToElement('lightspeed');$event.preventDefault();"
           [class.active]="currentSectionId === 'lightspeed'">
          Lightspeed
        </a>
      </li>
    </ul>

    <form class="form-inline">
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="loadingSubmit" [disabled]="loadingSubmit"
              type="button" (click)="onSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content" appScrollDetect>

    <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="pt-3 pl-md-4 pb-5 mb-6">
      <h2>
        {{ isNewMembership ? 'New Membership' : 'Edit Membership' }}
      </h2>

      <form (submit)="onSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8"
               appScrollSpy [spiedTags]="['H3']" (sectionChange)="onSectionChange($event)">

            <h3 class="mt-2" id="setup">Setup</h3>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="nameInput">Membership Name *</label>
                  <input id="nameInput" type="text" name="name"
                         class="form-control"
                         [(ngModel)]="membership.name"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <div class="form-text text-danger">{{ membershipErrors.name }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="purchase_type">Purchase Type</label>
                  <div [ngbTooltip]="isExistingNonDraftMembership() ? 'May not be changed for an existing non-draft membership.' : null">
                    <select id="purchase_type" name="purchase_type"
                            class="custom-select"
                            [(ngModel)]="membership.purchase_type"
                            (ngModelChange)="unsavedChanges = true;handlePurchaseTypeChange();"
                            [disabled]="isExistingNonDraftMembership()"
                            [class.disabled]="isExistingNonDraftMembership()">
                      <option [ngValue]="MembershipPurchaseType.recurring">
                        {{ getMembershipPurchaseTypeDisplay(MembershipPurchaseType.recurring) }}
                      </option>
                      <option [ngValue]="MembershipPurchaseType.prepaid">
                        {{ getMembershipPurchaseTypeDisplay(MembershipPurchaseType.prepaid) }}
                      </option>
                      <option [ngValue]="MembershipPurchaseType.benefit">
                        {{ getMembershipPurchaseTypeDisplay(MembershipPurchaseType.benefit) }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                A benefit membership may not be purchased directly, but can be configured as a benefit. For example, an event may be configured to grant a benefit membership for the duration of the event.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.purchase_type }}</div>
            </div>

            <div class="form-group indented-subsection"
                 *ngIf="membership.purchase_type === MembershipPurchaseType.benefit">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="max_benefit_grants_per_customer">Maximum Grants per Customer (optional)</label>
                  <input type="number" class="form-control"
                         id="max_benefit_grants_per_customer"
                         name="max_benefit_grants_per_customer"
                         min="1" step="1"
                         [(ngModel)]="membership.max_benefit_grants_per_customer"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                The most times one customer can receive this membership as a benefit, across every event, schedule and schedule exception that grants it. Leave blank for no limit. A grant that ended because its booking or reservation was cancelled, or because the benefit was removed from the session, does not count.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.max_benefit_grants_per_customer }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="isGroupSelect">Group Membership?</label>
                  <div [ngbTooltip]="getIsGroupReasonDisabled()">
                    <select id="isGroupSelect" name="is_group"
                            class="custom-select"
                            [(ngModel)]="membership.is_group"
                            (ngModelChange)="handleGroupTierChange(); unsavedChanges = true;"
                            [disabled]="getIsGroupReasonDisabled()"
                            [class.disabled]="getIsGroupReasonDisabled()">
                      <option [ngValue]="false">No</option>
                      <option [ngValue]="true">Yes</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-text text-danger">{{ membershipErrors.is_group }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="statusSelect">Status</label>
                  <select id="statusSelect" name="status"
                          class="custom-select"
                          [(ngModel)]="membership.status"
                          (ngModelChange)="unsavedChanges = true">
                    <option *ngFor="let status of getAvailableStatuses()"
                            [ngValue]="status">
                      {{ getMembershipStatusDisplay(status) }}
                    </option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                Once a membership is set to Active (or Retired), it may not be reverted to Draft and some of its basic properties (such as Payment Type and Group Membership) may no longer be changed.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.status }}</div>
            </div>

            <div class="form-group" *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="intervalSelect">Membership Length</label>
                  <div [ngbTooltip]="isExistingNonDraftMembership() ? 'May not be changed for an existing non-draft membership.' : null">
                    <select id="intervalSelect" name="interval"
                            class="custom-select"
                            [(ngModel)]="membership.interval"
                            (ngModelChange)="unsavedChanges = true"
                            [disabled]="isExistingNonDraftMembership()">
                      <option [ngValue]="MembershipInterval.weekly">Weekly</option>
                      <option [ngValue]="MembershipInterval.biweekly">Biweekly</option>
                      <option [ngValue]="MembershipInterval.fourWeeks">Four Weeks</option>
                      <option [ngValue]="MembershipInterval.monthly">Monthly</option>
                      <option [ngValue]="MembershipInterval.quarterly">Quarterly</option>
                      <option [ngValue]="MembershipInterval.halfYearly">Semiannual</option>
                      <option [ngValue]="MembershipInterval.yearly">Annual</option>
                    </select>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
               This is the time between payments.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.interval }}</div>
            </div>

            <div class="form-group" *ngIf="membership.purchase_type === MembershipPurchaseType.prepaid">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="durationSelect">Membership Duration</label>
                  <select id="durationSelect" name="durationSelect"
                          class="custom-select"
                          [(ngModel)]="membership.has_fixed_date_ranges"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">Fixed Duration</option>
                    <option [ngValue]="true">Fixed Date Range Options</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
               "Fixed Date Range Options" allows the membership to have one or more date ranges that the customer must choose from. This can be used, for example, to sell a membership for the summer.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.interval }}</div>

              <div class="indented-subsection mt-2">
                <ng-container *ngIf="membership.has_fixed_date_ranges">
                  <div class="rounded-table-wrapper rounded-table-tight mb-2">
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dateRangeOption of membership.date_range_options; let idx = index;">
                          <td>{{ dateStringFromISO8601(dateRangeOption.start_date) }}</td>
                          <td>{{ dateStringFromISO8601(dateRangeOption.end_date) }}</td>
                          <td class="table-sm-button-cell text-right">
                            <button class="btn btn-sm btn-outline-danger table-sm-button"
                                    type="button"
                                    (click)="membership.date_range_options.splice(idx, 1); unsavedChanges = true;">
                              Remove
                            </button>
                          </td>
                        </tr>
                        <tr *ngIf="membership.date_range_options.length === 0">
                          <td colspan="99" class="text-muted">
                            No Date Range Options Configured
                          </td>
                        </tr>
                        <tr>
                          <td colspan="99" class="table-sm-button-cell">
                            <button class="btn btn-outline-success btn-block table-sm-button"
                                    type="button"
                                    (click)="addDateRangeOption()">
                              Add Date Range Option
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="alert alert-info">
                    Any date range options with end dates in the past will not be shown to the user. If no date ranges are available, the membership may not be purchased.
                  </div>
                </ng-container>
                <ng-container *ngIf="!membership.has_fixed_date_ranges" class="indented-subsection">
                  <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <div class="input-group">
                        <input type="number" min="0"
                               name="duration_years"
                               class="form-control"
                               [(ngModel)]="membership.duration_years"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <span class="input-group-text">Years</span>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.duration_years }}</div>
                      <div class="input-group">
                        <input type="number" min="0"
                               name="duration_months"
                               class="form-control"
                               [(ngModel)]="membership.duration_months"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <span class="input-group-text">Months</span>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.duration_months }}</div>
                      <div class="input-group">
                        <input type="number" min="0"
                               name="duration_days"
                               class="form-control"
                               [(ngModel)]="membership.duration_days"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <span class="input-group-text">Days</span>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.duration_days }}</div>
                    </div>
                  </div>
                  <small class="form-text text-muted">
                   If this is changed, only new memberships will be affected; any memberships that have already been purchased will not be updated.
                  </small>
                </ng-container>
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="youthProgrammingSelect">Is this membership used for youth programming?</label>
                  <select id="youthProgrammingSelect" name="is_youth_programming"
                          class="custom-select"
                          [(ngModel)]="membership.is_youth_programming"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                Youth programming memberships function identically to regular memberships, but may be filtered separately in revenue reports and the customer list.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.is_youth_programming }}</div>
            </div>

            <div class="form-group" *ngIf="membership.purchase_type !== MembershipPurchaseType.benefit">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="allowChooseStartDateSelect">Allow customers to choose start date?</label>
                  <select id="allowChooseStartDateSelect" name="allow_selecting_start_date"
                          class="custom-select"
                          [(ngModel)]="membership.allow_selecting_start_date"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If a customer cannot select a start date, their membership will start as soon as they complete its purchase.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.allow_selecting_start_date }}</div>
            </div>

            <div class="form-group"
                 *ngIf="(membership.purchase_type === MembershipPurchaseType.recurring) && !isSubMonthlyMembershipInterval(membership.interval)">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="billDayOfMonthInput">Billing day of month (optional)</label>
                  <input id="billDayOfMonthInput" type="number" name="bill_day_of_month"
                         min="1" max="31"
                         class="form-control"
                         [(ngModel)]="membership.bill_day_of_month"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                If this field is provided, then memberships of this type will always bill on the given day of month. If the membership does not start on the given day, the first billing period will be prorated. If a given month has fewer days than the provided number, the bill will occur on the last day of that month instead.
                <br>
                If this is left blank, then memberships will bill on the day of month on which they originally started.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.bill_day_of_month }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="isStaffOnlySelect">Visibility</label>
                  <div [ngbTooltip]="getVisibilityReasonDisabled()">
                  <select id="isStaffOnlySelect" name="visibility"
                          class="custom-select"
                          [(ngModel)]="membership.visibility"
                          (ngModelChange)="unsavedChanges = true"
                          [disabled]="getVisibilityReasonDisabled()"
                          [class.disabled]="getVisibilityReasonDisabled()">
                    <option [ngValue]="MembershipVisibility.public">Public</option>
                    <option [ngValue]="MembershipVisibility.unlisted">Unlisted</option>
                    <option [ngValue]="MembershipVisibility.staffOnly">Staff Only</option>
                  </select>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                Unlisted memberships will not be listed as a purchase option on the "Memberships, Passes, and Voucher Packs" Climber App page, but may still be purchased by anyone with the link. Staff Only memberships may only be purchased by staff members.
              </small>
              <small class="form-text text-muted">
                When using the Unlisted option, in order to provide additional assurance that only the intended customers are purchasing the membership, you may additionally choose to take advantage of the "require staff approval" option below.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.visibility }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="hasIcon">Does this membership have an associated icon?</label>
                  <select id="hasIcon"
                          name="hasIcon"
                          class="custom-select"
                          [(ngModel)]="hasIcon"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                The icon will be displayed when a customer with an active membership checks in.
              </small>
            </div>

            <div *ngIf="hasIcon" class="indented-subsection">

              <div class="form-group row">
                <div class="col-lg-6 col-md-8 col-12">
                  <div class="form-group">
                    <label for="iconColorHexSelect">Icon Color</label>
                    <app-color-picker id="iconColorHexSelect"
                                      [(content)]="membership.icon_color_hex"
                                      (contentChange)="unsavedChanges = true"></app-color-picker>
                    <div class="form-text text-danger">{{ membershipErrors.icon_color_hex }}</div>
                  </div>
                  <div class="form-group">
                    <label for="iconInitialsInput">Icon Initials</label>
                    <input id="iconInitialsInput" type="text" class="form-control" name="icon_initials"
                           required maxlength="2"
                           [(ngModel)]="membership.icon_initials"
                           (ngModelChange)="unsavedChanges = true">
                    <small class="form-text text-muted">2 characters max</small>
                    <div class="form-text text-danger">{{ membershipErrors.icon_initials }}</div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-4 col-12" *ngIf="membership.icon_color_hex !== ''">
                  <div class="d-inline-block rounded-border p-3">
                    <label>Icon Preview</label>
                    <br>
                    <app-membership-icon [size]="2"
                                         [colorHex]="membership.icon_color_hex"
                                         [iconInitials]="membership.icon_initials"></app-membership-icon>
                  </div>
                </div>
              </div>

            </div>

            <h3 class="mt-2" id="benefits">Benefits</h3>

            <div class="form-group">
              <label for="num_new_customer_guest_passes">Number of "new customers only" guest passes</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input type="number"
                         id="num_new_customer_guest_passes"
                         name="num_new_customer_guest_passes"
                         min="0" max="100" step="1"
                         class="form-control"
                         [(ngModel)]="membership.num_new_customer_guest_passes"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                {{ orgConfig.getGuestPassEligibilityDescription(GuestPassEligibility.newCustomersOnly) }}
              </small>
              <div class="form-text text-danger">{{ membershipErrors.num_new_customer_guest_passes }}</div>
            </div>

            <div class="form-group row" *ngIf="membership.num_new_customer_guest_passes > 0">
              <div class="col-lg-6 col-md-8">
                <div class="indented-subsection">
                  <label for="new_customer_guest_pass_frequency">"New customers only" guest pass frequency</label>
                  <select id="new_customer_guest_pass_frequency" name="new_customer_guest_pass_frequency"
                          class="custom-select"
                          [(ngModel)]="membership.new_customer_guest_pass_frequency"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="MembershipInterval.daily">Daily</option>
                    <option [ngValue]="MembershipInterval.weekly">Weekly</option>
                    <option [ngValue]="MembershipInterval.monthly">Monthly</option>
                    <option [ngValue]="MembershipInterval.quarterly">Quarterly</option>
                    <option [ngValue]="MembershipInterval.halfYearly">Semiannual</option>
                    <option [ngValue]="MembershipInterval.yearly">Yearly</option>
                  </select>
                  <small class="form-text text-muted">
                    Guest passes are granted each calendar month/quarter/year and must be used within that month/quarter/year.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.new_customer_guest_pass_frequency }}</div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="num_lapsed_customer_guest_passes">Number of "lapsed customers only" guest passes</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input type="number"
                         id="num_lapsed_customer_guest_passes"
                         name="num_lapsed_customer_guest_passes"
                         min="0" max="100" step="1"
                         class="form-control"
                         [(ngModel)]="membership.num_lapsed_customer_guest_passes"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                {{ orgConfig.getGuestPassEligibilityDescription(GuestPassEligibility.lapsedCustomersOnly) }}
                The window is configured under <a routerLink="/organization-settings" target="_blank">Organization Settings</a>.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.num_lapsed_customer_guest_passes }}</div>
            </div>

            <div class="form-group row" *ngIf="membership.num_lapsed_customer_guest_passes > 0">
              <div class="col-lg-6 col-md-8">
                <div class="indented-subsection">
                  <label for="lapsed_customer_guest_pass_frequency">"Lapsed customers only" guest pass frequency</label>
                  <select id="lapsed_customer_guest_pass_frequency" name="lapsed_customer_guest_pass_frequency"
                          class="custom-select"
                          [(ngModel)]="membership.lapsed_customer_guest_pass_frequency"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="MembershipInterval.daily">Daily</option>
                    <option [ngValue]="MembershipInterval.weekly">Weekly</option>
                    <option [ngValue]="MembershipInterval.monthly">Monthly</option>
                    <option [ngValue]="MembershipInterval.quarterly">Quarterly</option>
                    <option [ngValue]="MembershipInterval.halfYearly">Semiannual</option>
                    <option [ngValue]="MembershipInterval.yearly">Yearly</option>
                  </select>
                  <small class="form-text text-muted">
                    Guest passes are granted each calendar month/quarter/year and must be used within that month/quarter/year.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.lapsed_customer_guest_pass_frequency }}</div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="num_all_customer_guest_passes">Number of "all customers" guest passes</label>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-5">
                  <input type="number"
                         id="num_all_customer_guest_passes"
                         name="num_all_customer_guest_passes"
                         min="0" max="100" step="1"
                         class="form-control"
                         [(ngModel)]="membership.num_all_customer_guest_passes"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                These guest passes may be used by any customer.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.num_all_customer_guest_passes }}</div>
            </div>

            <div class="form-group row" *ngIf="membership.num_all_customer_guest_passes > 0">
              <div class="col-lg-6 col-md-8">
                <div class="indented-subsection">
                  <label for="all_customer_guest_pass_frequency">"All customers" guest pass frequency</label>
                  <select id="all_customer_guest_pass_frequency" name="all_customer_guest_pass_frequency"
                          class="custom-select"
                          [(ngModel)]="membership.all_customer_guest_pass_frequency"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="MembershipInterval.daily">Daily</option>
                    <option [ngValue]="MembershipInterval.weekly">Weekly</option>
                    <option [ngValue]="MembershipInterval.monthly">Monthly</option>
                    <option [ngValue]="MembershipInterval.quarterly">Quarterly</option>
                    <option [ngValue]="MembershipInterval.halfYearly">Semiannual</option>
                    <option [ngValue]="MembershipInterval.yearly">Yearly</option>
                  </select>
                  <small class="form-text text-muted">
                    Guest passes are granted each calendar month/quarter/year and must be used within that month/quarter/year.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.all_customer_guest_pass_frequency }}</div>
                </div>
              </div>
            </div>

            <div class="alert alert-info">
              Changes to the guest pass policy will be applied to all existing members. The changes may require up to an hour to take effect.
            </div>

            <div class="row">
              <div class="form-group col-lg-6 col-md-8">
                <label for="voucherType">Booking Voucher Type</label>
                <select id="voucherType" name="voucherType"
                        class="custom-select"
                        [(ngModel)]="voucherType"
                        (ngModelChange)="unsavedChanges = true; unsavedVoucherChanges = true;">
                  <option [ngValue]="VoucherType.none">None</option>
                  <option [ngValue]="VoucherType.eventType">Event Type</option>
                  <option [ngValue]="VoucherType.eventCategory">Event Category</option>
                </select>
              </div>
            </div>

            <div class="indented-subsection" *ngIf="voucherType !== VoucherType.none">
              <div class="row" *ngIf="voucherType === VoucherType.eventType">
                <div class="form-group col-lg-6 col-md-8">
                  <label for="voucherTypeSelect">Voucher Event Type</label>
                  <select id="voucherTypeSelectLoading" class="custom-select" name="voucher_type"
                          *ngIf="loadingEventTypes" disabled>
                    <option>Loading...</option>
                  </select>
                  <select id="voucherTypeSelect" class="custom-select" name="voucher_type"
                          *ngIf="!loadingEventTypes"
                          [(ngModel)]="membership.voucher_type_id"
                          (ngModelChange)="unsavedChanges = true; unsavedVoucherChanges = true;">
                    <option [ngValue]="null" disabled>---</option>
                    <option *ngIf="membership.voucher_type_id && !eventTypeIdInList(membership.voucher_type_id)"
                            [ngValue]="membership.voucher_type_id">
                      {{ membership.voucher_type_name }}
                      <ng-container *ngIf="membership.voucher_type_status === EventTypeStatus.draft">(draft)</ng-container>
                      <ng-container *ngIf="membership.voucher_type_status === EventTypeStatus.retired">(retired)</ng-container>
                    </option>
                    <option *ngFor="let eventType of eventTypes"
                            [ngValue]="eventType.id">
                      {{ eventType.name }}
                    </option>
                  </select>
                  <small class="form-text text-muted">
                    Only active event types may be selected for booking vouchers.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.voucher_type_id }}</div>
                </div>
              </div>

              <div class="row" *ngIf="voucherType === VoucherType.eventCategory">
                <div class="form-group col-lg-6 col-md-8">
                  <label for="voucher_category_id">Voucher Event Category</label>
                  <select id="voucherCategorySelectLoading" class="custom-select" name="voucher_category_id"
                          *ngIf="loadingEventCategories" disabled>
                    <option>Loading...</option>
                  </select>
                  <select id="voucher_category_id" class="custom-select" name="voucher_category_id"
                          *ngIf="!loadingEventCategories"
                          [(ngModel)]="membership.voucher_category_id"
                          (ngModelChange)="unsavedChanges = true; unsavedVoucherChanges = true;">
                    <option [ngValue]="null" disabled>---</option>
                    <option *ngIf="eventCategoryRemoved(membership.voucher_category_id)"
                            [ngValue]="membership.voucher_category_id">
                      {{ membership.voucher_category_name }} (Removed)
                    </option>
                    <option *ngFor="let eventCategory of eventCategories"
                            [ngValue]="eventCategory.id">
                      {{ eventCategory.name }}
                    </option>
                  </select>
                  <div class="form-text text-danger">{{ membershipErrors.voucher_category_id }}</div>
                </div>
              </div>

              <div class="form-group">
                <label for="numVouchersInput">
                  Number of vouchers
                  <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                    per {{ getMembershipIntervalDisplaySingle(membership.interval) }}
                  </ng-container>
                  <ng-container *ngIf="membership.purchase_type !== MembershipPurchaseType.recurring">
                    included
                  </ng-container>
                </label>
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-5">
                    <input id="numVouchersInput" type="number" name="num_vouchers"
                           min="1" max="100" step="1"
                           class="form-control"
                           [(ngModel)]="membership.num_vouchers"
                           (ngModelChange)="unsavedChanges = true; unsavedVoucherChanges = true;">
                  </div>
                </div>
                <small class="form-text text-muted">
                  Vouchers will expire if not used by the end of the
                  <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                    {{ getMembershipIntervalDisplaySingle(membership.interval) }}.
                  </ng-container>
                  <ng-container *ngIf="membership.purchase_type !== MembershipPurchaseType.recurring">
                    membership.
                  </ng-container>
                </small>
                <div class="form-text text-danger">{{ membershipErrors.num_vouchers }}</div>
              </div>
            </div>

            <div class="alert alert-warning" *ngIf="unsavedVoucherChanges">
              Vouchers are applied when a membership is purchased, or a recurring membership is billed. Changes to the voucher policy will not affect existing members unless they are recurring, in which case vouchers will be granted at the next bill date.
            </div>

            <ng-container *ngIf="membership.purchase_type !== MembershipPurchaseType.benefit">

              <h3 class="mt-2" id="pricing">Pricing</h3>

              <app-membership-pricing-section
                [membership]="membership"
                [errors]="membershipErrors"
                [taxRates]="taxRates"
                [loadingTaxRates]="loadingTaxRates"
                [locations]="getLocations()"
                [isExistingNonDraftMembership]="isExistingNonDraftMembership()"
                [(hasPerLocationTaxRates)]="hasPerLocationTaxRates"
                [(hasPerLocationInitiationFeeTaxRates)]="hasPerLocationInitiationFeeTaxRates"
                (changed)="unsavedChanges = true"
                (refreshTaxRates)="loadTaxRates()">
              </app-membership-pricing-section>

            </ng-container>

            <h3 class="mt-2" id="policies">Policies</h3>

            <ng-container *ngIf="membership.purchase_type !== MembershipPurchaseType.benefit">

              <h6 class="mt-2"><b>Freeze Policies</b></h6>

              <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                <div class="form-group row">
                  <div class="col-lg-6 col-md-8">
                    <label for="allowFreezingSelect">Can customers freeze this membership?</label>
                    <select id="allowFreezingSelect" name="allow_freezing"
                            class="custom-select"
                            [(ngModel)]="membership.allow_freezing"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="true">Yes</option>
                      <option [ngValue]="false">No</option>
                    </select>
                    <small class="form-text text-muted">
                      If this is set to "No", then this membership may only be frozen by staff.
                    </small>
                    <div class="form-text text-danger">{{ membershipErrors.allow_freezing }}</div>
                  </div>
                </div>

                <div class="form-group row" *ngIf="membership.allow_freezing && membership.is_group">
                  <div class="col-lg-6 col-md-8">
                    <label for="allow_individual_freezing">Can customers freeze individual members of this membership?</label>
                    <select id="allow_individual_freezing" name="allow_individual_freezing"
                            class="custom-select"
                            [(ngModel)]="membership.allow_individual_freezing"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="true">Yes</option>
                      <option [ngValue]="false">No</option>
                    </select>
                    <small class="form-text text-muted">
                      If this is set to "No", then individual members of this membership may only be frozen by staff.
                    </small>
                    <div class="form-text text-danger">{{ membershipErrors.allow_individual_freezing }}</div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="membership.allow_freezing && (membership.purchase_type === MembershipPurchaseType.recurring)">
                <div class="form-group">
                  <label for="freezeWaitPeriodMonthsInput">
                    Minimum amount of time before a customer may freeze this membership (optional)
                  </label>
                  <div class="row">
                    <div class="col-lg-4 col-md-5 col-6">
                      <div class="input-group">
                        <input id="freezeWaitPeriodMonthsInput" type="number"
                               name="freeze_wait_period_months"
                               min="1" step="1"
                               class="form-control"
                               [(ngModel)]="membership.freeze_wait_period_months"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <div class="input-group-text">months</div>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.freeze_wait_period_months }}</div>
                    </div>
                    <div class="col-lg-4 col-md-5 col-6">
                      <div class="input-group">
                        <input id="freezeWaitPeriodWeeksInput" type="number"
                               name="freeze_wait_period_weeks"
                               min="1" step="1"
                               class="form-control"
                               [(ngModel)]="membership.freeze_wait_period_weeks"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <div class="input-group-text">weeks</div>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.freeze_wait_period_weeks }}</div>
                    </div>
                  </div>
                  <small class="form-text text-muted">
                    Customers will not be allowed to freeze their memberships until this amount of time has passed from purchase. Leave both fields blank in order to allow customers to freeze their membership at any time.
                  </small>
                </div>

                <div class="form-group">
                  <label for="freezeNoticePeriodMonthsInput">
                    Minimum advance notice before a customer may freeze this membership (optional)
                  </label>
                  <div class="row">
                    <div class="col-lg-4 col-md-5 col-6">
                      <div class="input-group">
                        <input id="freezeNoticePeriodMonthsInput" type="number"
                               name="freeze_notice_period_months"
                               min="1" step="1"
                               class="form-control"
                               [(ngModel)]="membership.freeze_notice_period_months"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <div class="input-group-text">months</div>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.freeze_notice_period_months }}</div>
                    </div>
                    <div class="col-lg-4 col-md-5 col-6">
                      <div class="input-group">
                        <input id="freezeNoticePeriodDaysInput" type="number"
                               name="freeze_notice_period_days"
                               min="1" step="1"
                               class="form-control"
                               [(ngModel)]="membership.freeze_notice_period_days"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <div class="input-group-text">days</div>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.freeze_notice_period_days }}</div>
                    </div>
                  </div>
                  <small class="form-text text-muted">
                    When freezing their memberships, customers will only be able to select billing dates which are at least this amount of time in the future. Leave both fields blank in order to allow customers to choose any billing date when freezing their membership.
                  </small>
                </div>

                <div class="form-group">
                  <label for="minimumFreezeTimeMonthsInput">
                    Minimum amount of time membership must be frozen (optional)
                  </label>
                  <div class="row">
                    <div class="col-lg-4 col-md-5 col-6">
                      <div class="input-group">
                        <input id="minimumFreezeTimeMonthsInput" type="number"
                               name="minimum_freeze_time_months"
                               min="1" step="1"
                               class="form-control"
                               [(ngModel)]="membership.minimum_freeze_time_months"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <div class="input-group-text">months</div>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.minimum_freeze_time_months }}</div>
                    </div>
                    <div class="col-lg-4 col-md-5 col-6">
                      <div class="input-group">
                        <input id="minimumFreezeTimeWeeksInput" type="number"
                               name="minimum_freeze_time_weeks"
                               min="1" step="1"
                               class="form-control"
                               [(ngModel)]="membership.minimum_freeze_time_weeks"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <div class="input-group-text">weeks</div>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.minimum_freeze_time_weeks }}</div>
                    </div>
                  </div>
                  <small class="form-text text-muted">
                    Customers will not be allowed to unfreeze their memberships until they have been frozen for this amount of time. Leave both fields blank in order to allow customers to unfreeze their membership at any time.
                  </small>
                </div>
              </ng-container>

              <div class="form-group">
                <label for="maximumFreezeTimeMonthsInput">
                  Maximum amount of time membership may be frozen (optional)
                </label>
                <div class="row">
                  <div class="col-lg-4 col-md-5 col-6">
                    <div class="input-group">
                      <input id="maximumFreezeTimeMonthsInput" type="number"
                             name="maximum_freeze_time_months"
                             min="1" step="1"
                             class="form-control"
                             [(ngModel)]="membership.maximum_freeze_time_months"
                             (ngModelChange)="unsavedChanges = true">
                      <div class="input-group-append">
                        <div class="input-group-text">months</div>
                      </div>
                    </div>
                    <div class="form-text text-danger">{{ membershipErrors.maximum_freeze_time_months }}</div>
                  </div>
                  <div class="col-lg-4 col-md-5 col-6">
                    <div class="input-group">
                      <input id="maximumFreezeTimeWeeksInput" type="number"
                             name="maximum_freeze_time_weeks"
                             min="1" step="1"
                             class="form-control"
                             [(ngModel)]="membership.maximum_freeze_time_weeks"
                             (ngModelChange)="unsavedChanges = true">
                      <div class="input-group-append">
                        <div class="input-group-text">weeks</div>
                      </div>
                    </div>
                    <div class="form-text text-danger">{{ membershipErrors.maximum_freeze_time_weeks }}</div>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If the membership is left frozen for this amount of time, it will be automatically reverted to Active. Leave both fields blank in order to allow memberships to be frozen indefinitely.
                </small>
              </div>

              <div class="form-group indented-subsection" *ngIf="membership.maximum_freeze_time_months || membership.maximum_freeze_time_weeks">
                <label for="cancel_membership_when_maximum_freeze_reached">
                  Action when maximum freeze time is reached
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <select id="cancel_membership_when_maximum_freeze_reached"
                            name="cancel_membership_when_maximum_freeze_reached"
                            class="custom-select"
                            [(ngModel)]="membership.cancel_membership_when_maximum_freeze_reached"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="false">Reactivate membership</option>
                      <option [ngValue]="true">Cancel membership</option>
                    </select>
                  </div>
                </div>
                <div class="form-text text-danger">{{ membershipErrors.cancel_membership_when_maximum_freeze_reached }}</div>
                <small class="form-text text-muted">
                  If "Reactivate membership" is selected, then the membership will be charged their normal recurring fee and reactivated when the maximum freeze time is reached.
                  <ng-container *ngIf="membership.is_group">
                    <br>
                    <span class="text-warning">This setting only applies when the entire membership is frozen. Individually-frozen members will always be reactivated when the maximum freeze time is reached.</span>
                  </ng-container>
                </small>
              </div>

              <div class="form-group row" *ngIf="membership.is_group">
                <div class="col-lg-6 col-md-8">
                  <label for="has_fixed_freeze_fee">Is the freeze fee per-member?</label>
                  <select id="has_fixed_freeze_fee" name="has_fixed_freeze_fee"
                          class="custom-select"
                          [(ngModel)]="membership.has_fixed_freeze_fee"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">Yes</option>
                    <option [ngValue]="true">No (fixed freeze fee)</option>
                  </select>
                  <div class="form-text text-danger">{{ membershipErrors.has_fixed_freeze_fee }}</div>
                </div>
              </div>

              <div class="form-group">
                <ng-container *ngIf="!membership.is_group || membership.has_fixed_freeze_fee">
                  <label for="freezeFeeInput">Freeze fee</label>
                  <div class="row">
                    <div class="input-group col-lg-3 col-md-4 col-sm-5">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
                      </div>
                      <input id="freezeFeeInput" type="number" name="freeze_fee"
                             placeholder="XXX.XX" min="0" step="0.01"
                             class="form-control"
                             [(ngModel)]="membership.freeze_fee"
                             (ngModelChange)="unsavedChanges = true">
                    </div>
                  </div>
                  <div class="form-text text-danger">{{ membershipErrors.freeze_fee }}</div>
                </ng-container>
                <ng-container *ngIf="membership.is_group && !membership.has_fixed_freeze_fee">
                  <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6">
                      <label for="adultFreezeFeeInput">Freeze fee per {{ membership.adult_tier_name }}</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
                        </div>
                        <input id="adultFreezeFeeInput" type="number" name="adult_freeze_fee"
                               placeholder="XXX.XX" min="0" step="0.01"
                               class="form-control"
                               [(ngModel)]="membership.adult_freeze_fee"
                               (ngModelChange)="unsavedChanges = true">
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.adult_freeze_fee }}</div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6" *ngIf="membership.has_youth_tier">
                      <label for="youthFreezeFeeInput">Freeze fee per {{ membership.youth_tier_name }}</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
                        </div>
                        <input id="youthFreezeFeeInput" type="number" name="youth_freeze_fee"
                               placeholder="XXX.XX" min="0" step="0.01"
                               class="form-control"
                               [(ngModel)]="membership.youth_freeze_fee"
                               (ngModelChange)="unsavedChanges = true">
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.youth_freeze_fee }}</div>
                    </div>
                  </div>
                </ng-container>
                <small class="form-text text-muted">
                  <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                    This amount will be charged each billing cycle for as long as the membership is frozen.
                  </ng-container>
                  <ng-container *ngIf="membership.purchase_type !== MembershipPurchaseType.recurring">
                    This amount will be charged at the time the membership is frozen.
                  </ng-container>
                </small>
              </div>

            </ng-container>

            <ng-container *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
              <h6 class="mt-2"><b>Cancellation Policies</b></h6>

              <div class="form-group row">
                <div class="col-lg-6 col-md-8">
                  <label for="allowCancellationSelect">Can customers cancel this membership?</label>
                  <select id="allowCancellationSelect" name="allow_cancellation"
                          class="custom-select"
                          [(ngModel)]="membership.allow_cancellation"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                  <div class="form-text text-danger">{{ membershipErrors.allow_cancellation }}</div>
                </div>
              </div>

              <ng-container *ngIf="membership.allow_cancellation">

                <div class="form-group">
                  <label for="cancellationWaitPeriodMonthsInput">
                    Minimum amount of time before a customer may cancel this membership (optional)
                  </label>
                  <div class="row">
                    <div class="col-lg-4 col-md-5 col-6">
                      <div class="input-group">
                        <input id="cancellationWaitPeriodMonthsInput" type="number"
                               name="cancellation_wait_period_months"
                               min="1" step="1"
                               class="form-control"
                               [(ngModel)]="membership.cancellation_wait_period_months"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <div class="input-group-text">months</div>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.cancellation_wait_period_months }}</div>
                    </div>
                    <div class="col-lg-4 col-md-5 col-6">
                      <div class="input-group">
                        <input id="cancellationWaitPeriodWeeksInput" type="number"
                               name="cancellation_wait_period_weeks"
                               min="1" step="1"
                               class="form-control"
                               [(ngModel)]="membership.cancellation_wait_period_weeks"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <div class="input-group-text">weeks</div>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.cancellation_wait_period_weeks }}</div>
                    </div>
                  </div>
                  <small class="form-text text-muted">
                    Customers will not be allowed to cancel their memberships until this amount of time has passed from purchase. Leave both fields blank in order to allow customers to cancel their membership at any time.
                  </small>
                </div>

                <div class="form-group">
                  <label for="cancellation_notice_period_months">
                    Minimum advance notice before a customer may cancel this membership (optional)
                  </label>
                  <div class="row">
                    <div class="col-lg-4 col-md-5 col-6">
                      <div class="input-group">
                        <input id="cancellation_notice_period_months" type="number"
                               name="cancellation_notice_period_months"
                               min="1" step="1"
                               class="form-control"
                               [(ngModel)]="membership.cancellation_notice_period_months"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <div class="input-group-text">months</div>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.cancellation_notice_period_months }}</div>
                    </div>
                    <div class="col-lg-4 col-md-5 col-6">
                      <div class="input-group">
                        <input id="cancellation_notice_period_days" type="number"
                               name="cancellation_notice_period_days"
                               min="1" step="1"
                               class="form-control"
                               [(ngModel)]="membership.cancellation_notice_period_days"
                               (ngModelChange)="unsavedChanges = true">
                        <div class="input-group-append">
                          <div class="input-group-text">days</div>
                        </div>
                      </div>
                      <div class="form-text text-danger">{{ membershipErrors.cancellation_notice_period_days }}</div>
                    </div>
                  </div>
                  <small class="form-text text-muted">
                    When cancelling their memberships, customers will only be able to select billing dates which are at least this amount of time in the future. Leave both fields blank in order to allow customers to choose any billing date when cancelling their membership.
                  </small>
                </div>

                <div class="form-group">
                  <label>
                    Date range in which a customer's cancellation may take effect (optional)
                  </label>
                  <div class="row">
                    <div class="col-lg-4 col-md-5 col-6">
                      <label for="cancellationDateRangeStartInput">Start Date</label>
                      <app-date-picker [id]="'cancellationDateRangeStartInput'"
                                       [(content)]="membership.cancellation_date_range_start"
                                       (contentChange)="unsavedChanges = true"></app-date-picker>
                      <div class="form-text text-danger">{{ membershipErrors.cancellation_date_range_start }}</div>
                    </div>
                    <div class="col-lg-4 col-md-5 col-6">
                      <label for="cancellationDateRangeEndInput">End Date</label>
                      <app-date-picker [id]="'cancellationDateRangeEndInput'"
                                       [(content)]="membership.cancellation_date_range_end"
                                       (contentChange)="unsavedChanges = true"></app-date-picker>
                      <div class="form-text text-danger">{{ membershipErrors.cancellation_date_range_end }}</div>
                    </div>
                  </div>
                  <small class="form-text text-muted">
                    When cancelling their memberships, customers will only be able to select billing dates within this range. Once the end date has passed, customers will not be able to cancel until the range is changed or removed. Leave both fields blank in order to allow customers to choose any billing date when cancelling their membership. Cancellations made by staff are not restricted.
                  </small>
                </div>

              </ng-container>
            </ng-container>

            <h6 class="mt-2"><b>Entry Restrictions</b></h6>

            <div class="form-group"
                 *ngIf="getLocations() && (getLocations().length > 1)">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="isSingleLocationSelect">
                    Is this membership restricted to a single location (customer choice)?
                  </label>
                  <select id="isSingleLocationSelect" name="is_single_location"
                          class="custom-select"
                          [(ngModel)]="membership.is_single_location"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this option is enabled, a customer purchasing this membership will need to select the location where the membership can be used. The customer will not be able to use the membership for check-in at any other location. Regardless of a customer's Home Location, revenue for the membership will be attributed to the membership's location.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.is_single_location }}</div>
            </div>

            <div class="form-group"
                 *ngIf="getLocations() && (getLocations().length > 1)">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="isLocationRestrictedSelect">
                    Is this membership restricted to a certain location or set of locations (fixed)?
                  </label>
                  <select id="isLocationRestrictedSelect" name="is_location_restricted"
                          class="custom-select"
                          [(ngModel)]="membership.is_location_restricted"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this option is enabled, the membership may only be used for check-in at a fixed set of locations. If "Is this membership restricted to a single location (customer choice)?" is also enabled, then the purchaser may only select from the configured set of locations.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.is_location_restricted }}</div>
            </div>

            <div class="form-group indented-subsection" *ngIf="membership.is_location_restricted">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label>
                    Allowed Locations
                  </label>
                  <ul class="mb-2 pl-3">
                    <li *ngFor="let location of membership.allowed_locations; let idx = index;">
                      {{ location.name }}
                      <a href="#" class="link-danger pl-1"
                         (click)="membership.allowed_locations.splice(idx, 1); unsavedChanges = true; $event.preventDefault();">
                        Remove
                      </a>
                    </li>
                    <li *ngIf="membership.allowed_locations.length === 0"
                        class="text-muted">
                      No locations selected
                    </li>
                  </ul>
                  <a href="#"
                     (click)="openAddAllowedLocationModal();$event.preventDefault();">
                    Select Location
                  </a>
                  <div class="form-text text-danger">{{ membershipErrors.allowed_locations }}</div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-6 col-md-8">
                <label for="hasLimitedEntrySelect">
                  Is this membership limited to entry at certain days/times?
                </label>
                <select id="hasLimitedEntrySelect" name="has_limited_entry"
                        class="custom-select"
                        [(ngModel)]="membership.has_limited_entry"
                        (ngModelChange)="unsavedChanges = true">
                  <option [ngValue]="true">Yes</option>
                  <option [ngValue]="false">No</option>
                </select>
                <div class="form-text text-danger">{{ membershipErrors.has_limited_entry }}</div>
              </div>
            </div>

            <div class="form-group indented-subsection" *ngIf="membership.has_limited_entry">
              <p><b>Times when this membership may be used for entry:</b></p>

              <ng-container *ngFor="let timeSlot of entryTimeSlots">
                <div class="form-group">
                  <div class="row">
                    <div class="col-4">
                      <label>Start Time *</label>
                      <input type="time" step="60"
                             class="form-control"
                             [name]="'startTime' + timeSlot.id.toString()"
                             [(ngModel)]="timeSlot.start_time"
                             (ngModelChange)="unsavedChanges = true">
                      <div class="form-text text-danger"
                           *ngIf="entryTimeSlotErrors[timeSlot.id]">
                        {{ entryTimeSlotErrors[timeSlot.id].start_time }}
                      </div>
                    </div>
                    <div class="col-4">
                      <label>End Time *</label>
                      <input type="time" step="60"
                             class="form-control"
                             [name]="'endTime' + timeSlot.id.toString()"
                             [(ngModel)]="timeSlot.end_time"
                             (ngModelChange)="unsavedChanges = true">
                      <div class="form-text text-danger"
                           *ngIf="entryTimeSlotErrors[timeSlot.id]">
                        {{ entryTimeSlotErrors[timeSlot.id].end_time }}
                      </div>
                    </div>
                    <div class="col-4">
                      <button class="btn btn-danger btn-sm float-right"
                              (click)="removeEntryTimeSlot(timeSlot); unsavedChanges = true;">
                        Remove Time Slot
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>Days Available *</label>
                  <br>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_sunday"
                          [class.btn-primary]="timeSlot.is_available_sunday"
                          (click)="timeSlot.is_available_sunday = !timeSlot.is_available_sunday; unsavedChanges = true;">
                    S
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_monday"
                          [class.btn-primary]="timeSlot.is_available_monday"
                          (click)="timeSlot.is_available_monday = !timeSlot.is_available_monday; unsavedChanges = true;">
                    M
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_tuesday"
                          [class.btn-primary]="timeSlot.is_available_tuesday"
                          (click)="timeSlot.is_available_tuesday = !timeSlot.is_available_tuesday; unsavedChanges = true;">
                    T
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_wednesday"
                          [class.btn-primary]="timeSlot.is_available_wednesday"
                          (click)="timeSlot.is_available_wednesday = !timeSlot.is_available_wednesday; unsavedChanges = true;">
                    W
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_thursday"
                          [class.btn-primary]="timeSlot.is_available_thursday"
                          (click)="timeSlot.is_available_thursday = !timeSlot.is_available_thursday; unsavedChanges = true;">
                    T
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_friday"
                          [class.btn-primary]="timeSlot.is_available_friday"
                          (click)="timeSlot.is_available_friday = !timeSlot.is_available_friday; unsavedChanges = true;">
                    F
                  </button>
                  <button class="btn mr-2 day-button" type="button"
                          [class.btn-outline-secondary]="!timeSlot.is_available_saturday"
                          [class.btn-primary]="timeSlot.is_available_saturday"
                          (click)="timeSlot.is_available_saturday = !timeSlot.is_available_saturday; unsavedChanges = true;">
                    S
                  </button>
                  <br>
                  <button class="btn btn-link btn-sm pl-0" type="button"
                          *ngIf="!allDaysAreAvailable(timeSlot)"
                          (click)="setAllDaysAvailability(timeSlot, true); unsavedChanges = true;">
                    Select All
                  </button>
                  <button class="btn btn-link btn-sm pl-0" type="button"
                          *ngIf="allDaysAreAvailable(timeSlot)"
                          (click)="setAllDaysAvailability(timeSlot, false); unsavedChanges = true;">
                    Deselect All
                  </button>
                </div>

                <div class="alert alert-danger" role="alert"
                     *ngIf="entryTimeSlotErrors[timeSlot.id] && entryTimeSlotErrors[timeSlot.id].non_field_errors">
                  {{ entryTimeSlotErrors[timeSlot.id].non_field_errors }}
                </div>

                <hr>
              </ng-container>

              <button class="btn btn-sm btn-link pl-0 mb-3" type="button"
                      (click)="addNewEntryTimeSlot(); unsavedChanges = true;">
                + Add New Time Period
              </button>
            </div>

            <div class="form-group row" *ngIf="usesSpecificAllthenticateProducts()">
              <div class="col-lg-6 col-md-8">
                <label for="sendsAllthenticateInviteSelect">
                  Does this membership grant Allthenticate door access?
                </label>
                <select id="sendsAllthenticateInviteSelect" name="sends_allthenticate_invite"
                        class="custom-select"
                        [(ngModel)]="membership.sends_allthenticate_invite"
                        (ngModelChange)="unsavedChanges = true">
                  <option [ngValue]="true">Yes</option>
                  <option [ngValue]="false">No</option>
                </select>
                <small class="form-text text-muted">
                  Customers who buy this membership, or who are added to it, are
                  sent an Allthenticate invite.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.sends_allthenticate_invite }}</div>
              </div>
            </div>

            <ng-container *ngIf="membership.purchase_type !== MembershipPurchaseType.benefit">

              <h6 class="mt-2"><b>Purchase Restrictions</b></h6>

              <div class="form-group row">
                <div class="col-lg-6 col-md-8">
                  <label for="isNewMembersOnlySelect">Is this membership restricted to new members?</label>
                  <select id="isNewMembersOnlySelect" name="is_new_members_only"
                          class="custom-select"
                          [(ngModel)]="membership.is_new_members_only"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="false">No</option>
                    <option [ngValue]="true">Yes</option>
                  </select>
                  <small class="form-text text-muted">
                    If this option is enabled, this membership may only be purchased for customers who have not previously held a membership.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.is_new_members_only }}</div>
                </div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <label for="allowUnlinkedPurchaseSelect">Allow Purchase for Unlinked Customers</label>
                    <select id="allowUnlinkedPurchaseSelect" name="allow_purchasing_for_unlinked_customers"
                            class="custom-select"
                            [(ngModel)]="membership.allow_purchasing_for_unlinked_customers"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="true">Yes</option>
                      <option [ngValue]="false">No</option>
                    </select>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If this is set to "Yes", then customers may manually enter the member's name and birthday when purchasing a membership, in addition to the options of purchasing the membership for themselves or a linked customer. If the manually-entered details cannot be matched to an existing customer, a new customer account will be created.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.allow_purchasing_for_unlinked_customers }}</div>
              </div>

              <div class="form-group" *ngIf="membership.allow_purchasing_for_unlinked_customers">
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <label for="allowPurchaseWithoutLoginSelect">Allow Purchase when Not Logged Into Climber App</label>
                    <select id="allowPurchaseWithoutLoginSelect" name="allow_purchase_without_login"
                            class="custom-select"
                            [(ngModel)]="membership.allow_purchase_without_login"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="true">Yes</option>
                      <option [ngValue]="false">No</option>
                    </select>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If this is set to "Yes", then customers may purchase this membership without being logged in to the Climber App. They will be asked to enter their name, birthday, and email address instead.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.allow_purchase_without_login }}</div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <label for="requireStaffApprovalSelect">Does this membership require staff approval?</label>
                    <select id="requireStaffApprovalSelect" name="require_staff_approval"
                            class="custom-select"
                            [(ngModel)]="membership.require_staff_approval"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="true">Yes</option>
                      <option [ngValue]="false">No</option>
                    </select>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If this is set to "Yes", then a newly-purchased membership of this type will be placed in a "Pending" state and a "Memberships Pending Approval" inbox item will be created for it. If a customer with a pending membership attempts to check in, an error message will be displayed prompting staff to review their membership.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.require_staff_approval }}</div>
              </div>

            </ng-container>

            <h3 class="mt-2" id="climber-app-text">Climber App Text</h3>

            <ng-container *ngIf="membership.purchase_type !== MembershipPurchaseType.benefit">

              <div class="form-group row">
                <div class="col-lg-10">
                  <label>Membership Description</label>
                  <app-markdown-editor [id]="'descriptionTextarea'"
                                       [(content)]="membership.description"
                                       (contentChange)="unsavedChanges = true"
                                       [shortEditor]="true"></app-markdown-editor>
                  <small class="form-text text-muted">
                    This will be viewable by customers if they can purchase this membership online.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.description }}</div>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-10">
                  <label>Terms and Conditions Checkbox Text</label>
                  <app-markdown-editor [id]="'tsAndCsCheckboxText'"
                                       [(content)]="membership.terms_and_conditions_checkbox_text"
                                       (contentChange)="unsavedChanges = true"
                                       [shortEditor]="true"></app-markdown-editor>
                  <small class="form-text text-muted">
                    This text will be shown alongside a checkbox which must be checked by the customer before purchasing this membership. If this is left blank, no checkbox will be shown and it will not be required.
                  </small>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-10">
                  <label>Membership Confirmation Text</label>
                  <app-markdown-editor [id]="'confirmationTextArea'"
                                       [(content)]="membership.confirmation_text"
                                       (contentChange)="unsavedChanges = true"
                                       [shortEditor]="true"></app-markdown-editor>
                  <small class="form-text text-muted">
                    This will be shown to customers on the confirmation screen after they purchase this membership online.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.confirmation_text }}</div>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-lg-10">
                  <label>Payment Information Text</label>
                  <app-markdown-editor [id]="'paymentInfoTextArea'"
                                       [(content)]="membership.payment_information_text"
                                       (contentChange)="unsavedChanges = true"
                                       [shortEditor]="true"></app-markdown-editor>
                  <small class="form-text text-muted">
                    This will be shown to customers on their receipt after they purchase this membership online.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.payment_information_text }}</div>
                </div>
              </div>

              <div class="form-group row" *ngIf="membership.upfront_payment_options.length > 0">
                <div class="col-lg-10">
                  <label>Upfront Payment Information Text</label>
                  <app-markdown-editor [id]="'upfront_payment_climber_app_text'"
                                       [(content)]="membership.upfront_payment_climber_app_text"
                                       (contentChange)="unsavedChanges = true"
                                       [shortEditor]="true"></app-markdown-editor>
                  <small class="form-text text-muted">
                    If provided, this text will be shown to customers in an "info alert" at the top of the page when they are prompted to choose an upfront payment option.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.upfront_payment_climber_app_text }}</div>
                </div>
              </div>

              <div class="form-group row" *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                <div class="col-lg-10">
                  <label>Recurring Payment Confirmation Text</label>
                  <app-markdown-editor [id]="'recurringPaymentConfirmationTextArea'"
                                       [(content)]="membership.recurring_payment_confirmation_text"
                                       (contentChange)="unsavedChanges = true"
                                       [shortEditor]="true"></app-markdown-editor>
                  <small class="form-text text-muted">
                    This will be included in the confirmation email sent to membership owners when recurring payments are charged. This is <b>not</b> included in the confirmation email sent when the membership is initially purchased.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.recurring_payment_confirmation_text }}</div>
                </div>
              </div>

              <div class="form-group row" *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                <div class="col-lg-10">
                  <label>Failed Payment Notification Text</label>
                  <app-markdown-editor [id]="'failedPaymentNotificationTextArea'"
                                       [(content)]="membership.failed_payment_notification_text"
                                       (contentChange)="unsavedChanges = true"
                                       [shortEditor]="true"></app-markdown-editor>
                  <small class="form-text text-muted">
                    This will be included in the notification email sent to membership owners when recurring payments fail.
                  </small>
                  <div class="form-text text-danger">{{ membershipErrors.failed_payment_notification_text }}</div>
                </div>
              </div>

            </ng-container>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>
                  Membership Management Info Text
                </label>
                <app-markdown-editor [id]="'membership_management_info_alert_text'"
                                     [(content)]="membership.membership_management_info_alert_text"
                                     (contentChange)="unsavedChanges = true"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  Add any additional information you want displayed on the Membership Management page in the Climber App here. This text will be displayed in a blue info box at the bottom of the page.
                  <br>
                  This can be used for information such as who to contact if a customer has additional questions, terms & conditions, etc.
                </small>
                <div class="form-text text-danger">
                  {{ membershipErrors.membership_management_info_alert_text }}
                </div>
              </div>
            </div>

            <div class="form-group"
                 *ngIf="membership.purchase_type !== MembershipPurchaseType.benefit">
              <label for="order_number">Order Number</label>
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <input id="order_number"
                         name="order_number"
                         class="form-control"
                         type="number"
                         step="1"
                         [(ngModel)]="membership.order_number"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <small class="form-text text-muted">
                This determines the order that memberships are displayed in the Climber App. Lower numbers are displayed first. If two memberships have the same order number, they will be displayed in the order that they were created.
              </small>
              <div class="form-text text-danger">{{ membershipErrors.order_number }}</div>
            </div>

            <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().has_mailchimp_integration">
              <h3 class="mt-2" id="mailchimp">Mailchimp Tags and Events</h3>

              <p class="text-muted">
                To learn more, see our
                <a href="https://capitan.helpscoutdocs.com/article/200-mailchimp-events-and-tags"
                   target="_blank" rel="noopener">support article on the Capitan Mailchimp integration</a>.
              </p>

              <p class="mb-1">
                The following tags and events are synced to Mailchimp automatically for all memberships of this type:
              </p>
              <div class="rounded-table-wrapper rounded-table-tight mb-3 mailchimp-auto-events-table">
                <table class="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Synced To</th>
                      <th>When</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Active Member</td>
                      <td>Tag</td>
                      <td>Members</td>
                      <td>While the membership is active</td>
                    </tr>
                    <tr>
                      <td>Frozen Member</td>
                      <td>Tag</td>
                      <td>Members</td>
                      <td>While the membership is frozen</td>
                    </tr>
                    <tr>
                      <td><code>membership_purchased_by_cust</code></td>
                      <td>Event</td>
                      <td>Owner</td>
                      <td>When the membership is purchased</td>
                    </tr>
                    <tr>
                      <td><code>membership_purchased_for_cust</code></td>
                      <td>Event</td>
                      <td>Member(s)</td>
                      <td>When the membership is purchased</td>
                    </tr>
                    <tr *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                      <td><code>membership_scheduled_to_cancel</code></td>
                      <td>Event</td>
                      <td>Owner</td>
                      <td>When the membership is scheduled to cancel</td>
                    </tr>
                    <tr>
                      <td><code>membership_cancelled</code></td>
                      <td>Event</td>
                      <td>Owner</td>
                      <td>
                        When the membership
                        {{ (membership.purchase_type === MembershipPurchaseType.recurring) ? 'is cancelled' : 'ends' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="form-group">
                <label for="mailchimpPurchasedByCustomerEventNameInput">
                  "Membership Purchased By Customer" Event Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpPurchasedByCustomerEventNameInput"
                           type="text" name="mailchimp_purchased_by_customer_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="membership.mailchimp_purchased_by_customer_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for the membership owner whenever a membership of this type is purchased.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.mailchimp_purchased_by_customer_event_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpPurchasedForCustomerEventNameInput">
                  "Membership Purchased For Customer" Event Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpPurchasedForCustomerEventNameInput"
                           type="text" name="mailchimp_purchased_for_customer_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="membership.mailchimp_purchased_for_customer_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for each member whenever a membership of this type is purchased.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.mailchimp_purchased_for_customer_event_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpActiveMemberTagNameInput">
                  "Active Member" Tag Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpActiveMemberTagNameInput"
                           type="text" name="mailchimp_active_member_tag_name"
                           maxlength="64"
                           class="form-control"
                           [(ngModel)]="membership.mailchimp_active_member_tag_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this tag will be assigned in Mailchimp to all members of active memberships of this type.
                  <br>
                  It may take up to 15 minutes to update all existing members when this field is changed.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.mailchimp_active_member_tag_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpActiveMembershipOwnerTagNameInput">
                  "Active Membership Owner" Tag Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpActiveMembershipOwnerTagNameInput"
                           type="text" name="mailchimp_active_membership_owner_tag_name"
                           maxlength="64"
                           class="form-control"
                           [(ngModel)]="membership.mailchimp_active_membership_owner_tag_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this tag will be assigned in Mailchimp to all owners of active memberships of this type.
                  <br>
                  It may take up to 15 minutes to update all existing owners when this field is changed.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.mailchimp_active_membership_owner_tag_name }}</div>
              </div>

              <div class="form-group">
                <label for="mailchimpMembershipCancelledEventNameInput">
                  "Membership
                  {{ (membership.purchase_type === MembershipPurchaseType.recurring) ? 'Cancelled' : 'Ended' }}"
                  Event Name
                </label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpMembershipCancelledEventNameInput"
                           type="text" name="mailchimp_cancelled_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="membership.mailchimp_cancelled_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for the membership owner whenever a membership of this type
                  {{ (membership.purchase_type === MembershipPurchaseType.recurring) ? 'is cancelled' : 'ends' }}.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.mailchimp_cancelled_event_name }}</div>
              </div>

              <div class="form-group" *ngIf="membership.purchase_type === MembershipPurchaseType.recurring">
                <label for="mailchimpMembershipScheduledToCancelEventNameInput">"Membership Scheduled to Cancel" Event Name</label>
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <input id="mailchimpMembershipScheduledToCancelEventNameInput"
                           type="text" name="mailchimp_scheduled_to_cancel_event_name"
                           maxlength="30"
                           class="form-control"
                           [(ngModel)]="membership.mailchimp_scheduled_to_cancel_event_name"
                           (ngModelChange)="unsavedChanges = true">
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this event will be created in Mailchimp for the membership owner whenever a membership of this type is scheduled to cancel.
                  <br>
                  Mailchimp event names must be between 2 and 30 characters in length, and must consist only of letters, numbers, underscores, and dashes.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.mailchimp_scheduled_to_cancel_event_name }}</div>
              </div>
            </ng-container>

            <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().pos_software === OrgPOSSoftware.square">
              <h3 class="mt-2" id="square">Square Customer Groups</h3>

              <div class="alert alert-info">
                In order for a Square customer group to be available for configuration, it must first be enabled as "managed by Capitan" by navigating to
                <a routerLink="/organization-settings" target="_blank">Organization Settings</a>
                and selecting "Manage Customer Groups" in the Integrations section.
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-lg-8 col-md-10">
                    <label for="memberSquareCustomerGroupSelect">
                      "Active Member" Customer Group
                    </label>
                    <div class="float-right mb-1">
                      <a href="#"
                         (click)="$event.preventDefault();resyncSquareCustomerGroups();">
                        Resync Customer Groups
                      </a>
                    </div>
                    <select id="memberSquareCustomerGroupSelectLoading"
                            class="custom-select" name="member_square_customer_group_id"
                            *ngIf="loadingSquareCustomerGroups" disabled>
                      <option>Loading...</option>
                    </select>
                    <select id="memberSquareCustomerGroupSelect"
                            class="custom-select" name="member_square_customer_group_id"
                            *ngIf="!loadingSquareCustomerGroups"
                            [(ngModel)]="membership.member_square_customer_group_id"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="null">None</option>
                      <option *ngFor="let squareCustomerGroup of squareCustomerGroups"
                              [ngValue]="squareCustomerGroup.id">
                        {{ squareCustomerGroup.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this customer group will be assigned in Square to all members of active memberships of this type.
                  <br>
                  It may take up to 15 minutes to update all existing members when this field is changed.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.member_square_customer_group_id }}</div>
              </div>

            </ng-container>

            <ng-container *ngIf="orgConfig.getOrganizationConfig() && orgConfig.getOrganizationConfig().pos_software === OrgPOSSoftware.lightspeed">
              <h3 class="mt-2" id="lightspeed">Lightspeed Customer Groups</h3>

              <div class="alert alert-info">
                In order for a Lightspeed customer group to be available for configuration, it must first be enabled as "managed by Capitan" by navigating to
                <a routerLink="/organization-settings" target="_blank">Organization Settings</a>
                and selecting "Manage Customer Groups" in the Integrations section.
              </div>

              <div class="alert alert-info">
                Lightspeed only allows a customer to be assigned to a single group. When a customer qualifies for multiple groups, Capitan will assign the customer to the group with the highest ranking. The group rankings may be updated in
                <a routerLink="/organization-settings">Organization Settings</a>.
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-lg-8 col-md-10">
                    <label for="memberLightspeedCustomerGroupSelect">
                      "Active Member" Customer Group
                    </label>
                    <div class="float-right mb-1">
                      <a href="#"
                         (click)="$event.preventDefault();resyncLightspeedCustomerGroups();">
                        Resync Customer Groups
                      </a>
                    </div>
                    <select id="memberLightspeedCustomerGroupSelectLoading"
                            class="custom-select" name="member_lightspeed_customer_group_id"
                            *ngIf="loadingLightspeedCustomerGroups" disabled>
                      <option>Loading...</option>
                    </select>
                    <select id="memberLightspeedCustomerGroupSelect"
                            class="custom-select" name="member_lightspeed_customer_group_id"
                            *ngIf="!loadingLightspeedCustomerGroups"
                            [(ngModel)]="membership.member_lightspeed_customer_group_id"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="null">None</option>
                      <option *ngFor="let lightspeedCustomerGroup of lightspeedCustomerGroups"
                              [ngValue]="lightspeedCustomerGroup.id">
                        {{ lightspeedCustomerGroup.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If provided, this customer group will be assigned in Lightspeed to all members of active memberships of this type.
                  <br>
                  It may take up to 15 minutes to update all existing members when this field is changed.
                </small>
                <div class="form-text text-danger">{{ membershipErrors.member_lightspeed_customer_group_id }}</div>
              </div>

            </ng-container>

            <app-last-updated-by-footer
              [updatedAt]="membership.updated_at"
              [firstName]="membership.last_updated_by_first_name"
              [lastName]="membership.last_updated_by_last_name"
              [email]="membership.last_updated_by_email"
            ></app-last-updated-by-footer>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>
